import React from 'react';
import PhotoFrameMany from './PhotoFrameMany';
import SectionTitle from './SectionTitle';
import SectionText from './SectionText';

// the following imports contents to populate the textual components
import './Main.css';
import './FoodAndDrinks.css';
import {foodsSectionMainText} from '../data/foods/foodsSectionMainText';

// Swiper add 
// the following imports images to populate the image frames (PhotoFrame and PhotoFrameMany)
import {foods} from '../data/foods/foods';
import {drinks} from '../data/foods/drinks';

// This lays out the main page, including the header (navbar), footer, and everything in between
// All contents are in terms of components, with Main as the mother of components 

function FoodAndDrinks(props) {

    // Prepare headings for bilingual 
    // set language icon, menu items and texts based on the language state from props.language
    var foodsHeading = '', drinksHeading = '', foodsDescription = '', drinksDescription = '';
    if (props.language === 'en') {
        foodsHeading = foodsSectionMainText[0].name;
        drinksHeading = foodsSectionMainText[1].name;
        foodsDescription = foodsSectionMainText[0].text;
        drinksDescription = foodsSectionMainText[1].text;
        // console.log('LOG - ', foodsDescription);
    } else if (props.language === 'jp') {
        foodsHeading = foodsSectionMainText[0].nameJ;
        drinksHeading = foodsSectionMainText[1].nameJ;
        foodsDescription = foodsSectionMainText[0].textJ;
        drinksDescription = foodsSectionMainText[1].textJ;
    } else if (props.language === 'ch1') {
        foodsHeading = foodsSectionMainText[0].nameCh1;
        drinksHeading = foodsSectionMainText[1].nameCh1;
        foodsDescription = foodsSectionMainText[0].textCh1;
        drinksDescription = foodsSectionMainText[1].textCh1;
        
    } else if (props.language === 'ch2') {
        foodsHeading = foodsSectionMainText[0].nameCh2;
        drinksHeading = foodsSectionMainText[1].nameCh2;
        foodsDescription = foodsSectionMainText[0].textCh2;
        drinksDescription = foodsSectionMainText[1].textCh2;
    } else {}

    // scroll to the top of the page when coming from another route
    window.scroll(0,0);

    /* swiper add: This block code processes the Food Types Section (foods.js), prepares PhotoFrameMany components */
    const foodsContent = foods.map(food => {
        var categoryCaption = '', categoryName = '';
        if (props.language === 'en' ) { categoryCaption = food.text; categoryName = food.name; }
        else if (props.language === 'jp' ) { categoryCaption = food.textJ; categoryName = food.nameJ; }
        else if (props.language === 'ch1' ) { categoryCaption = food.textCh1; categoryName = food.nameCh1; }
        else if (props.language === 'ch2' ) { categoryCaption = food.textCh2; categoryName = food.nameCh2; }
        else {}

        // console.log('XXXXX in foodsContent food - ', food);

        return (
            <div key={food.id} className='categoryContainer'>
                <div className='imagesContainer col-6 col-md-full col-sm-full'>
                    <div className='photoFrameManyContainer1'>
                        <PhotoFrameMany images={food.images} caption={''} contentType={''} fontIsBlack='false'/>
                    </div> 
                </div>
                <div className='captionWordsContainer col-6 col-md-full col-sm-full'>
                    <div className='categoryName'>{categoryName}</div>
                    <div className='categoryCaption'>{categoryCaption}</div> 
                </div>
            </div>
            // <div key={food.id} className='col-6 col-md-full col-sm-full'>
            //     <div className='photoFrameManyContainer1'>
            //         <PhotoFrameMany images={food.images} caption={categoryCaption} contentType={categoryName} fontIsBlack='false'/>
            //     </div> 
            // </div>
        )
    })

    /* swiper add: This block code processes the Drinks Types Section (drinks.js), prepares PhotoFrameMany components */
    const drinksContent = drinks.map(drink => {
        var categoryCaption = '', categoryName = '';
        if (props.language === 'en' ) { categoryCaption = drink.text; categoryName = drink.name; }
        else if (props.language === 'jp' ) { categoryCaption = drink.textJ; categoryName = drink.nameJ; }
        else if (props.language === 'ch1' ) { categoryCaption = drink.textCh1; categoryName = drink.nameCh1; }
        else if (props.language === 'ch2' ) { categoryCaption = drink.textCh2; categoryName = drink.nameCh2; }
        else {}

        return (
            <div key={drink.id} className='categoryContainer'>
                <div className='col-6 col-md-full col-sm-full'>
                    <div className='photoFrameManyContainer1'>
                        <PhotoFrameMany images={drink.images} caption={''} contentType={''} fontIsBlack='false'/>
                    </div> 
                </div>
                <div className='captionWordsContainer col-6 col-md-full col-sm-full'>
                    <div className='categoryName'>{categoryName}</div>
                    <div className='categoryCaption'>{categoryCaption}</div> 
                </div>
            </div>
        )
    })

    return (
        <div className='foodsContainer'>

            {/* This block is rendering of foods section of the page */}
            <div className='foodsSection' >
                <SectionTitle ids='foods' title={foodsHeading} />
                <div className='sectionMain'>
                    <SectionText text={foodsSectionMainText} language={props.language} />
                </div>
                {foodsContent}
                {/* <div className='sectionEnd sectionMain' >{foodsContent}</div> 
                <div className='sectionEnd'>{}</div> */}
            {/* </div> */}

            {/* This block is rendering of drinks section of the page */}
            {/* <div className='drinksSection' > */}
                <SectionTitle ids='drinks' title={drinksHeading} />
                <div className='sectionMain'>
                    <SectionText text={foodsSectionMainText} language={props.language} />
                </div>
                {drinksContent}
                {/* <div className='sectionEnd sectionMain' >{drinksContent}</div> 
                <div className='sectionEnd'>{}</div> */}
                <div className='sectionEnd'>{}</div>
            </div>
        </div>
    )
}

export default FoodAndDrinks;